import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { deleteBulletin } from 'services/fund'

export default function useDeleteBulletin(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: {
            moneypoolId: string | undefined
            id: number
        }) => {
            return deleteBulletin(payload)
        },
        onSuccess: (data) => {
            toast.success('  با موفقیت حذف یافت')
            refetch()
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { isLoading, mutate }
}
